import app from '../app';

app.controller("CustomerController", CustomerController);

/*@ngInject*/
function CustomerController(customer, formlyFieldsService) {
    var vm = this;
    vm.detailsModel = null;
    vm.detailsBlankModel = {
        firstName: null,
        lastName: null,
        email: null,
        userName: null
    };
    vm.detailsFields = [
        {
            key: 'userName',
            type: 'input',
            name: 'usertName',
            templateOptions: {
                label: 'Username',
                placeholder: 'Username',
                required: true,
                disabled: true
            }
        },
        {
            key: 'firstName',
            type: 'input',
            name: 'firstName',
            templateOptions: {
                label: 'First Name',
                placeholder: 'First Name',
                required: true,
                disabled: true
            }
        },
        {
            key: 'lastName',
            name: 'lastName',
            type: 'input',
            templateOptions: {
                label: 'Last Name',
                placeholder: 'Last Name',
                required: true,
                disabled: true
            }
        },
        {
            key: 'email',
            name: 'primary_contactinfo_email',
            type: 'input',
            templateOptions: {
                label: 'Email Address',
                placeholder: 'Email Address',
                disabled: true
            }
        }
    ];

    vm.passwordModel = {};
    vm.passwordBlankModel = {
        password: null
    };
    vm.passwordFields = [
        {
            key: 'password',
            type: 'input',
            name: 'password',
            templateOptions: {
                labelOptions: {
                    label: 'Current Password'
                },
                type: 'password',
                placeholder: 'Current Password',
                required: true,
                disabled: true
            }
        },
        {
            key: 'newPassword',
            type: 'input',
            name: 'newPassword',
            templateOptions: {
                labelOptions: {
                    label: 'New Password'
                },
                type: 'password',
                placeholder: 'New Password',
                required: true,
                disabled: true
            }
        },
        {
            key: 'confirmNewPassword',
            type: 'input',
            name: 'confirmNewPassword',
            templateOptions: {
                labelOptions: {
                    label: 'Confirm New Password'
                },
                type: 'password',
                placeholder: 'Confirm New Password',
                required: true,
                disabled: true
            },
            controller: /*@ngInject*/($scope) => {
                $scope.$watch('model.confirmNewPassword', (newValue) => {
                    if (newValue !== $scope.model.newPassword) {
                        $scope.fc.$setValidity('passwordMatch', false);
                    }
                });
            },
            validation: {
                messages: {
                    passwordMatch: () => 'Passwords have to match!'
                }
            }
        }
    ];

    activate();

    function activate() {
        console.log("customerppp", customer);
        vm.detailsModel = angular.copy(vm.detailsBlankModel);
        vm.detailsFormVisible = true;
        vm.detailsModel.firstName = customer.first_names;
        vm.detailsModel.lastName = customer.last_name;
        vm.detailsModel.email = customer.primary_contactinfo.email;
        vm.detailsModel.userName = customer.username;
    }

}



// WEBPACK FOOTER //
// ./static/js/app/customer/customer.controller.js